module.exports = __webpack_public_path__ + "static/media/creditCard.378a6488.svg";